export default __webpack_public_path__ + "static/media/36I-102797_-15936_0.7de58333.jpg";